import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const UPSELL_CONTEXT_SYMBOL = Symbol();
const useUpsell = ()=>useImmutableContext(UPSELL_CONTEXT_SYMBOL);
const useUpsellProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(UPSELL_CONTEXT_SYMBOL, ...args);
};
export { useUpsell, useUpsellProvider };
